import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const toggleQrcode = (qrcodeId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_QRCODE_ACTIVE_STATUS.METHOD](APIConfig.TOGGLE_QRCODE_ACTIVE_STATUS.URL(qrcodeId), payload);
}
const addQrcode = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_NEW_QR_CODE.METHOD](APIConfig.ADD_NEW_QR_CODE.URL   , payload);
}

const QrCodeService = {
    toggleQrcode,
    addQrcode
}
export default QrCodeService;